module.exports = __webpack_public_path__ + "5df1aed21bc9626dea7c9caead9ddf3f.svg";